<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="h-screen loginscreen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="container">
      <vs-row class="justify-center">
        <vs-col vs-lg="9" vs-md="10" vs-sm="8" vs-xs="12" vs="12">

          <div v-if="showForm">
            <vx-card>
            <div slot="no-body" class="full-page-bg-color">
              <vs-row class="vx-row no-gutter justify-center">
                <vs-col vs-lg="5" vs-md="6" vs-sm="12" vs-xs="12">
                  <div class="vx-row loginlogoouter no-gutter justify-center">
                    <div class="loginlogo">
                      <img src="@/assets/images/logo/ilerno-logo.svg" alt="login">
                    </div>
                  </div>
                </vs-col>
                <vs-col vs-lg="7" vs-md="6" vs-sm="12" vs-xs="12" class="d-theme-dark-bg self-center">
                  <div class="login-tabs-container">
                    <div class="vx-card__title">
                      <h2><b>Welcome to {{ customerData.customerName }}</b></h2>
                      <p>Please login to your account.</p>
                    </div>
                    <div class="flex flex-wrap justify-between">
                      <span class="flex items-center linkaccounttxt">
                        Link an account to this device
                        <i class="material-icons ml-2">error_outline</i>
                      </span>

                      <div class="linkaccountbtn">
                        
                        <vs-button
                          type="border"
                          color="primary" 
                          @click="redirectToLogin()"
                          >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-qr-code" viewBox="0 0 16 16"> 
                            <path d="M2 2h2v2H2V2Z"/> <path d="M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z"/> 
                            <path d="M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z"/> 
                            <path d="M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z"/> 
                            <path d="M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z"/> 
                          </svg>
                           Link Account
                        </vs-button>
                        
                      </div>
                    </div>
                    <div class="pt-0">
                      <login-jwt :subdomain="subdomain"></login-jwt>
                    </div>

                  </div>
                </vs-col>
              </vs-row>
            </div>
            </vx-card>
          </div>
          <div v-else-if="showError">
            <vx-card>
              <h4 class="text-center">🚨 Error: Invalid Domain Detected! 🚨</h4><br>
              <p>It looks like the domain you entered might be incorrect.</p>
              <p>To fix this:</p>
              <p>Recheck the domain name for any typos or errors and ensure you're entering the correct domain.</p><br>

              <p><b>🛠 Need Help?</b></p>
              <p>Don't worry, we're here for you! Contact our support team at support@ilerno.com for personalized assistance.</p><br>
              <p>Thank You,</p>
              <p><b>The ilerno Support Team</b></p>

            </vx-card>
          </div>

        </vs-col>
      </vs-row>
    </div>
  </div>
</template>


<script>
import { fetchCustomerDataBySubdomainAPI } from '@/api/login'
import LoginJwt from './LoginJWT.vue'
import { URLMixins } from "@/mixins/url/url-with-domain";

export default {
  components: {
    LoginJwt
    // LoginFirebase,
    // LoginAuth0
  },
  mixins: [
            URLMixins,
  ],
  data() {
    return {
      cookieDataObject: null,
      getCookie: null,
      subdomain: '',
      customerData : {
          customerId : '',
          customerName: '',
          customerDomain: ''
      },
      showForm: false,
      showError: false,
    }
  },
  created () {
    const hostname = window.location.hostname
    this.subdomain = hostname.split('.')[0]

    if (this.subdomain === 'googleredirect') {
      // User is redirected after google cloud oauth
      // check src/views/pages/google-authenticate/googleauthenticate.vue
    } else {
      localStorage.setItem('subdomain', this.subdomain)
      this.fetchCustomerDataBySubdomain ()
    }
  },
  mounted () {

  },
  methods: {
    redirectToLogin () {
      console.log('redirectToLogin')
      this.$router.push('/qr-code');
    },
    async fetchCustomerDataBySubdomain ()
    {
      this.$vs.loading({})

      try
      {
        const payload = {
          'subdomain' : this.subdomain,
        }
        const response = await fetchCustomerDataBySubdomainAPI(payload)
        console.log('fetchCustomerDataBySubdomainAPI response: ', response.data.data)

        const showPlans = response.data.data.show_plans
        if (showPlans)
        {
          console.log('showPlans: ', showPlans)
          let paddlePlans = response.data.data.plans
          this.$router.push({
            name: 'paddle-products',
            params: { plansParams: paddlePlans }
          })
        }
        else
        {
          this.handleLoginPageView(response)
        }

        this.$vs.loading.close()
      }
      catch (apiError)
      {
        this.$vs.loading.close()
        this.showError = true
        console.log('fetchCustomerDataBySubdomainAPI err: ',apiError)
      }
    },

    handleLoginPageView(response)
    {
      const data = response.data.data.customerData
      if (data.id !== undefined )
      {
        this.customerData.customerId = data.id
        this.customerData.customerName = data.brand_company_name
        this.customerData.customerDomain = data.subdomain_name

        // Check if cookie is present meaning, user is not logout, so make it direct login
        this.checkCookieData()

        if (this.getCookie.length && this.cookieDataObject)
        {
          console.log('cookied found for loggedIn user')
          if ((this.customerData.customerDomain === this.cookieDataObject.cdomain) &&
            this.cookieDataObject.token &&
            (this.cookieDataObject.type === 'staff')
          ) {
            // Redirect to staff portal URL
            const staffURL = this.makeUrlDomain(this.customerData.customerDomain) + 'staff/dashboard';
            console.log('staffURL: ', staffURL)
            window.location.href = staffURL;
          }
        }
        else
        {
          this.showForm = true
        }
      }
    },

    checkCookieData()
    {
      try {
        const domainPart = this.getDomainPart();

        let unifiedLoginURL = '';
        let customerDomain = this.customerData.customerDomain.replaceAll("\"", "")
        unifiedLoginURL = this.makeUrlDomain(customerDomain)

        let cookieName = '';

        if (domainPart === 'localhost') {
          cookieName = `musicdemo.localhost_user_session`; // Dynamic cookie name
        } else {
          cookieName = `${unifiedLoginURL}_user_session`; // Dynamic cookie name
        }

        // Extract the actual cookie string
        this.getCookie = document.cookie.split('; ').filter(cookie => cookie.startsWith(`${cookieName}=`));

        // TESTING DATA
        // this.getCookie = [ 'musicdemo.localhost_user_session=token="4700|NM9Dung61e0RCTTYdtAmZdoj57lKOG3OZV55qgD395ee88d8"|cid=61|cname="Music Academy"|cdomain="musicdemo"|user={"id":627,"branches_id":61,"first_name":"Ivan","middle_name":null,"last_name":"Lerno","email_verified":"1","picture":"https://ilerno-dev-development-file-bucket.s3.eu-west-2.amazonaws.com/small/20230714052317392726/Default/E5LqMMdGS9qhL1tJ.jpg","platform_type":"WEB","device_key":"","user_type":"staff","role_name":"root admin"}|type="staff"' ]

        if (this.getCookie.length)
        {
          const cookieString = this.getCookie[0];
          const dataPart = cookieString.substring(cookieString.indexOf('=') + 1); // Extract everything after '='

          const decodedData = decodeURIComponent(dataPart);

          this.cookieDataObject = this.parseCookieData(decodedData);
        }

      } catch (error) {
          console.log('checkCookieData error: ', error)
      }
    },

    parseCookieData(cookieString)
    {
      try {
          const dataObject = {};

          // Split entries by '|' safely
          const entries = cookieString.split('|');

          entries.forEach(entry => {
              const [key, rawValue] = entry.split('=').map(str => str.trim());

              // Skip invalid entries
              if (!key || !rawValue) return;

              let value = rawValue;

              // Clean up quotes
              if (value.startsWith('"') && value.endsWith('"')) {
                  value = value.slice(1, -1);
              }

              // JSON detection (safer than regex)
              if (value.startsWith('{') && value.endsWith('}')) {
                  try {
                      value = JSON.parse(value);
                  } catch (error) {
                      console.warn(`Failed to parse JSON data for key "${key}":`, error);
                  }
              }

              dataObject[key] = value;
          });

          return dataObject;
      }
      catch (error) {
        console.error('parseCookieData error:', error);
        return {};
      }
    }

  },
}
</script>
<style lang="scss">
  @import "@/assets/scss/login.scss";
</style>

